import _ from 'lodash';

export default {
  computed: {
    contentItem() {
      return this.$store.state.contentItem;
    },
    contentItemRevisions() {
      return this.$store.state.contentItemRevisions;
    },
    selectedRevision() {
      return _.find(this.contentItemRevisions, { selected: true });
    },
    contentGroups() {
      return _(this.$store.state.content)
        .groupBy((content) => content.contentId.split('.')[0])
        .keys()
        .reject((k) => k === 'Colors')
        .value();
    },
    contentTypes() {
      return _(this.$store.state.content)
        .groupBy('type')
        .keys()
        .value();
    },
    activeColorsForSwatches() {
      return _(this.$store.state.content)
        .filter((content) => content.contentId.includes('Colors'))
        .map((content) => [content.content])
        .value();
    },
  },
  methods: {
    contentItemInfo(contentId) {
      const split = contentId.split('.');
      const rawDimensions = contentId.match(/(Width-\d+|Height-\d+)/g);
      const dimensions = {};
      let element = _.startCase(split.slice(1));

      if (rawDimensions) {
        [element] = contentId.split(`.${rawDimensions[0]}`);
        element = _.startCase(element.split('.').slice(1));

        _.each(rawDimensions, (dim) => {
          const [, width] = dim.split('Width-');
          const [, height] = dim.split('Height-');

          if (width) {
            dimensions.width = width;
          }

          if (height) {
            dimensions.height = height;
          }
        });
      }

      return {
        section: _.startCase(split[0]),
        element,
        dimensions,
      };
    },
    updateContentItem(action) {
      this.$store.dispatch('updateContentItem', action)
        .then(() => {
          this.goToContentList();
        });
    },
    updateActiveContentItemVersion() {
      this.$store.dispatch('updateActiveContentItemVersion', this.selectedRevision)
        .then(() => {
          this.goToContentList();
        });
    },
    selectRevision(revision) {
      _.each(this.contentItemRevisions, (rev) => {
        this.$set(rev, 'selected', false);
      });

      this.$set(revision, 'selected', true);
    },
    removeContentItem(action) {
      this.$store.dispatch('removeContentItem', action)
        .then(() => {
          this.goToContentList();
        });
    },
  },
};
